module.exports = __webpack_public_path__ + "img/icon_drill.5fb201e3.png";